const filterNonNumeric = (value: string) => {
  return value.replace(/\D/g, '')
}

export default filterNonNumeric
